import { render, staticRenderFns } from "./GuardCodeEditDetailsTab.vue?vue&type=template&id=59b3084f"
import script from "./GuardCodeEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./GuardCodeEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports